import { jsx as o } from "react/jsx-runtime";
import { TEST_IDS as s } from "./testIds.mjs";
import { Tooltip as n } from "./index58.mjs";
import { HelpIcon as P } from "./styles30.mjs";
const d = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, -11]
      }
    }
  ]
}, S = ({
  testId: r = s.informer,
  trigger: t = "hover",
  placement: e = "top",
  size: i = "medium",
  info: m,
  tooltipConfig: p,
  ...f
}) => /* @__PURE__ */ o(
  n,
  {
    trigger: t,
    ...p,
    title: m,
    placement: e,
    ...f,
    PopperProps: d,
    children: /* @__PURE__ */ o(P, { $size: i, "data-testid": r })
  }
);
export {
  S as Informer
};
//# sourceMappingURL=index48.mjs.map
